import styled from 'styled-components'
const Controls = styled.div`
  display: flex;
  margin-top: 24px;
  align-items: center;
`
export default Controls
